import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";

let cache = null;
let cachePromise = null;

export function useBookingConfig() {
  const [config, setConfig] = useState(cache);
  useEffect(() => {
    if (cache) { setConfig(cache); return; }
    if (!cachePromise) cachePromise = api.get("/config").then((r) => { cache = r.data; return r.data; }).catch(() => null);
    cachePromise.then((d) => d && setConfig(d));
  }, []);
  return config;
}

export default function BookingClosedBanner() {
  const config = useBookingConfig();
  const { locale } = useI18n();
  if (!config || config.booking_open) return null;
  const msg = locale === "fr" ? config.booking_message_fr : config.booking_message_en;
  return (
    <div data-testid="booking-closed-banner"
         className="p-4 mb-6"
         style={{ background: "var(--parchment-2)", border: "1px solid var(--gold)" }}>
      <div className="flex items-start gap-3">
        <div className="font-display text-2xl" style={{ color: "var(--cinnabar)" }}>⚠</div>
        <div className="flex-1">
          <div className="font-caps text-[0.7rem] mb-1" style={{ color: "var(--cinnabar)" }}>
            {locale === "fr" ? "Ouverture des inscriptions prévue fin juin 2026" : "Bookings opening end of June 2026"}
          </div>
          <p className="font-body text-sm" style={{ color: "var(--ink-2)" }}>{msg}</p>
        </div>
      </div>
    </div>
  );
}
